import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CURRENCY_SYMBOLS = { AUD: "A$", NZD: "NZ$", USD: "$", EUR: "€" };

export function fmt(amount, currency = "AUD") {
  const sym = CURRENCY_SYMBOLS[currency] || "$";
  const n = Number(amount || 0);
  return `${n < 0 ? "-" : ""}${sym}${Math.abs(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function fmtCompact(amount, currency = "AUD") {
  const sym = CURRENCY_SYMBOLS[currency] || "$";
  const n = Number(amount || 0);
  const abs = Math.abs(n);
  let v;
  if (abs >= 1_000_000) v = (n / 1_000_000).toFixed(1) + "M";
  else if (abs >= 1_000) v = (n / 1_000).toFixed(1) + "K";
  else v = n.toFixed(0);
  return `${sym}${v}`;
}
